$(document).ready(function() {  
  $('.thumbnail-list__item.product_featuired_media button').click();
  $(".ugc-video-item").hover(
    function () {
      $(".ugc-video-item").removeClass("active");
      $(this).addClass("active");
    },
    function () {
      // $(this).removeClass("result_hover");
    }
  );
  
  $('.video_poster_img').mouseover(function() {
    $('.video_poster_img').removeClass('hideback');
    $('.playbtn').show();
    $('.videin').each(function() {
        $(this).get(0).pause();
    });
    $(this).parents('.ugc-video-item').find('.videin')[0].play();
    $(this).parents('.ugc-video-item').find('.playbtn').hide();
    
    $(this).addClass('hideback');
  })
})

$(document).ready(function(){
  var mainCarousel = $('.main-carousel');
  var thumbnailsCarousel = $('.thumbnails-carousel');
  var flag = false; // Single synchronization flag

  // Initialize the main carousel
  mainCarousel.owlCarousel({
    items: 1,
    loop: true,
    dots: false,
    nav: true,
    navText: ["<i class='fa fa-chevron-left'></i>", "<i class='fa fa-chevron-right'></i>"]
  }).on('changed.owl.carousel', function(event) {
    if (flag) return;
    flag = true;
    syncCarousels(event.item.index, thumbnailsCarousel, $(this)); // Pass the main carousel jQuery object
  });

  $('.carousel-scroll-container').owlCarousel({
    items: 2,
    margin: 12,
    loop: true,
    dots: false,
    autoplay: true,
    nav: false,
    stagePadding: 40,
    responsive:{
      0:{ items: 1 },
      600:{ items: 2 },
      1000:{ items: 2 }
    }
  })

  // Initialize the thumbnail carousel
  thumbnailsCarousel.owlCarousel({
    items: 1,
    margin: 20,
    loop: true,
    dots: true,
    autoplay: true,
    nav: false,
    stagePadding: 100,
    responsive:{
      0:{ items: 1, margin: 4, stagePadding: 60 },
      600:{ items: 1, stagePadding: 80 },
      1000:{ items: 1 }
    }
  }).on('initialized.owl.carousel', function() {
    thumbnailsCarousel.find('.owl-item').eq(0).addClass('synced');
  }).on('changed.owl.carousel', function(event) {
    if (flag) return;
    flag = true;
    syncCarousels(event.item.index, mainCarousel, $(this)); // Pass the thumbnail carousel jQuery object
    var ss = $('.main-carousel .owl-item.active .item').attr('data-id');
    $('.main-image-slide').hide();
    $('.main-image-slide[data-index='+ss+']').show();
  });

  // Click handler for thumbnails
  thumbnailsCarousel.on('click', '.owl-item', function(e) {
    e.preventDefault();
    var owl = thumbnailsCarousel.data('owl.carousel');
    var realIndex = owl.relative($(this).index());
    mainCarousel.trigger('to.owl.carousel', [realIndex, 300, true]);
  });

  // Unified function to sync the carousels
  function syncCarousels(current, targetCarousel, sourceCarousel) {
    var owl = targetCarousel.data('owl.carousel');
    var realIndex;

    // Get the real index from the source carousel
    var sourceOwl = sourceCarousel.data('owl.carousel');
    if (sourceOwl.settings.loop) {
      realIndex = sourceOwl.relative(current);
    } else {
      realIndex = current;
    }

    // Trigger the slide change on the target carousel
    targetCarousel.trigger('to.owl.carousel', [realIndex, 300, true]);

    // Update the 'synced' class on the thumbnails
    if (targetCarousel.hasClass('thumbnails-carousel')) {
      targetCarousel.find('.owl-item').removeClass('synced');
      targetCarousel.find('.owl-item').eq(realIndex).addClass('synced');
    }
    
    // Reset the flag after a short delay
    setTimeout(function() {
      flag = false;
    }, 400); 
  }

  $('.Faq__Item').click(function() {
    var v = $(this).attr('aria-expanded');
    if (v == 'true') {
      $(this).attr('aria-expanded', 'false');
    } else {
      $(this).attr('aria-expanded', 'true');      
    }
    $(this).find('.Faq__AnswerWrapper').slideToggle();
  });

$('h3.feat_content_block__title, h3.feature-card__heading, .feature-grid-block h3').click(function() {
  $(this).next().slideToggle();
  $(this).toggleClass('active');
});
  

});

let items=document.querySelectorAll(".mega-menu");$("a.header__menu-item").hover(function(){$(".mega-menu").removeAttr("open")}),items.forEach(item=>{const content=item.querySelector(".mega-menu__content");item.addEventListener("mouseover",()=>{$(".mega-menu").removeAttr("open"),item.setAttribute("open",!0)}),item.addEventListener("mouseleave",()=>{let close=!0;content.addEventListener("mouseover",()=>{close=!1}),setTimeout(1e3,()=>{close&&item.removeAttribute("open")})}),content.addEventListener("mouseleave",()=>{item.removeAttribute("open")})}),$(document).ready(function(){$(document).on("click","button.slider-button_slider-button--next",function(e){e.preventDefault(),e.stopPropagation(),$("button.slider-button_slider-button--prev").removeClass("disabled"),$('button.thumbnail[aria-current="true"]').parent().next().attr("data-media-position")||$(this).addClass("disabled"),$('button.thumbnail[aria-current="true"]').parent().next().find("button").trigger("click")}),$(document).on("click","button.slider-button_slider-button--prev",function(e){e.preventDefault(),e.stopPropagation(),$("button.slider-button_slider-button--next").removeClass("disabled"),$('button.thumbnail[aria-current="true"]').parent().prev().attr("data-media-position")||$(this).addClass("disabled"),$('button.thumbnail[aria-current="true"]').parent().prev().find("button").trigger("click")}),$(window).on("resize",function(e){checkScreenSize()}),checkScreenSize();function checkScreenSize(){var newWindowWidth=$(window).width();$(".advantedge-prod-disc-section-content.medium-up-hide.owl-carousel").owlCarousel({margin:20,nav:!0,dots:!0,items:1,autoplay:!0, loop: !0}),$(".aadvan-column-images-sec").owlCarousel({margin:20,nav:!1,dots:!1,responsive:{0:{items:1,stagePadding:40},600:{items:2},1e3:{items:3}}})}function refreshCarousel(){owlscontext.trigger("destroy.owl.carousel").removeClass("owl-carousel owl-loaded"),$(".slider-content-text-info").addClass("owl-carousel"),$(".slider-content-text-info").owlCarousel({margin:20,nav:!0,dots:!1,stagePadding:60,autoplaySpeed:2200,autoplayTimeout:2200,slideTransition:"linear",autoplayHoverPause:!0,onInitialized:onInitializedFn,onResize:refreshCarousel,onChange:onChangeOwl,responsive:{0:{items:1,center:!0,stagePadding:25,loop:!0},600:{items:1},1e3:{items:1}}})}var owlscontext=$(".slider-content-text-info").owlCarousel({margin:20,nav:!0,dots:!1,stagePadding:60,slideTransition:"linear",autoplaySpeed:2200,autoplayTimeout:2200,autoplayHoverPause:!0,onInitialized:onInitializedFn,onResize:refreshCarousel,onChange:onChangeOwl,responsive:{0:{items:1,center:!0,stagePadding:25,loop:!0},600:{items:1},1e3:{items:1}}});function onInitializedFn(){setTimeout(function(){$(".text-with-slideshow").addClass("loadedd")},500)}$(".slidercstm").owlCarousel({margin:20,loop:!0,nav:!1,dots:!0,stagePadding:0,autoplay:!1,items:1}),$(".carousel_cl").owlCarousel({loop:!1,nav:!1,dots:!1,stagePadding:0,autoplay:!1,autoplaySpeed:2200,autoplayTimeout:2200,slideTransition:"linear",autoplayHoverPause:!0,items:1});function onChangeOwl(){setTimeout(function(){$(".text-with-slideshow").find(".owl-prev").hasClass("disabled")&&($(".cst_owl-prev").addClass("disabled"),$(".cst_owl-next").removeClass("disabled")),$(".text-with-slideshow").find(".owl-next").hasClass("disabled")&&($(".cst_owl-next").addClass("disabled"),$(".cst_owl-prev").removeClass("disabled"))},100)}$(".cst_owl-prev").click(function(){$(this).parents(".text-with-slideshow").find(".owl-prev").click()}),$(".cst_owl-next").click(function(){$(this).parents(".text-with-slideshow").find(".owl-next").click()}),$(".carousel_upsell").owlCarousel({margin:10,nav:!1,autoplayTimeout:3500,autoplayHoverPause:!0,items:1,stagePadding:40})}),$(document).on("click",".btn.add-upsell-btn-in",function(e){e.preventDefault(),e.stopPropagation();var that=$(this);if(that.hasClass("propage")&&$(this).attr("disabled"))return;const cartLink=document.querySelector("#cart-icon-bubble");$(this).find("span").hide(),$(this).find(".loading-overlay__spinner").removeClass("hidden");var id=$(this).attr("dataid"),items2={id,quantity:1};$.ajax({type:"POST",url:"/cart/add.js",dataType:"json",data:items2,success:function(res){$("cart-drawer-items").hasClass("is-empty")?$.ajax({type:"GET",url:`${routes.cart_url}?view=fullcartdrawer`,success:function(htm){$("cart-drawer ").removeClass("is-empty"),$("cart-drawer ").html(htm),that.find("span").show(),that.find(".loading-overlay__spinner").addClass("hidden"),$(".modal").removeClass("is-visible"),that.hasClass("propage")&&$("cart-drawer").addClass("animate active"),$(".carousel_upsell").owlCarousel({margin:10,nav:!1,autoplayTimeout:3500,autoplayHoverPause:!0,items:1,stagePadding:40})},error:function(err){console.log(err),that.find("span").show(),that.find(".loading-overlay__spinner").addClass("hidden")}}):$.ajax({type:"GET",url:`${routes.cart_url}?view=rendercart`,success:function(htm){$("#CartDrawer-CartItems").html(htm),that.find("span").show(),that.find(".loading-overlay__spinner").addClass("hidden"),$(".modal").removeClass("is-visible"),that.hasClass("propage")&&$("cart-drawer").addClass("animate active"),$(".carousel_upsell").owlCarousel({margin:10,nav:!1,autoplayTimeout:3500,autoplayHoverPause:!0,items:1,stagePadding:40})},error:function(err){console.log(err),that.find("span").show(),that.find(".loading-overlay__spinner").addClass("hidden")}}),$.ajax({type:"GET",url:`${routes.cart_url}?view=freeshippingbar`,success:function(htm){$(".Cart__ShippingNotice").html(htm)},error:function(err){console.log(err),that.find("span").show(),that.find(".loading-overlay__spinner").addClass("hidden")}}),jQuery.getJSON("/cart.js",function(cart){if($(".cart-count-bubble")[0])$(".cart-count-bubble span").html(cart.item_count);else{var dt='<div class="cart-count-bubble"><span aria-hidden="true">'+cart.item_count+'</span><span class="visually-hidden">'+cart.item_count+" item</span> </div>";$("#cart-icon-bubble").append(dt)}cartLink.click()})},error:function(err){console.log(err),that.find("span").show(),that.find(".loading-overlay__spinner").addClass("hidden")}})});var loc=location.href;if(loc.includes("/products")){let mouseIsDown2=function(e){isDown=!0,startY=e.pageY-containerAdvantedge.offsetTop,startX=e.pageX-containerAdvantedge.offsetLeft,scrollLeft=containerAdvantedge.scrollLeft,scrollTop=containerAdvantedge.scrollTop},mouseUp2=function(e){isDown=!1},mouseLeave2=function(e){isDown=!1},mouseMove2=function(e){if(isDown){e.preventDefault();const walkY=e.pageY-containerAdvantedge.offsetTop-startY;containerAdvantedge.scrollTop=scrollTop-walkY;const walkX=e.pageX-containerAdvantedge.offsetLeft-startX;containerAdvantedge.scrollLeft=scrollLeft-walkX}};var mouseIsDown=mouseIsDown2,mouseUp=mouseUp2,mouseLeave=mouseLeave2,mouseMove=mouseMove2;const containerAdvantedge=document.querySelector(".thumbnail-list");let startY,startX,scrollLeft,scrollTop,isDown;containerAdvantedge.addEventListener("mousedown",e=>mouseIsDown2(e)),containerAdvantedge.addEventListener("mouseup",e=>mouseUp2(e)),containerAdvantedge.addEventListener("mouseleave",e=>mouseLeave2(e)),containerAdvantedge.addEventListener("mousemove",e=>mouseMove2(e))}


//# sourceMappingURL=/s/files/1/0776/0160/3899/t/5/assets/custom.js.map?v=1738391063

function updateKachingElements() {
  // 1. Wrap selects (Div -> Span -> Select)
  document.querySelectorAll('.kaching-bundles__free-gift .kaching-bundles__bar-variant-select').forEach((select) => {
    if (select.parentElement.classList.contains('select-field-wrapper')) return;

    const labelText = select.getAttribute('aria-label');
    if (!labelText) return;

    const wrapper = document.createElement('div');
    wrapper.className = 'select-field-wrapper';

    const label = document.createElement('span');
    label.className = 'custom-aria-label';
    label.textContent = labelText;

    select.parentNode.insertBefore(wrapper, select);
    wrapper.appendChild(label);
    wrapper.appendChild(select);
  });

  // 2. Wrap "+ FREE" in custom span
  document.querySelectorAll('.kaching-bundles__free-gift__text').forEach((badge) => {
    if (badge.dataset.freeFormatted === 'true') return;

    if (badge.textContent.includes('FREE')) {
      badge.innerHTML = badge.innerHTML.replace(
        'FREE',
        '<span class="custom-free-badge">FREE</span>'
      );
      badge.dataset.freeFormatted = 'true';
    }
  });

  // 3. Handle unselected state prefixes & suffixes
  document.querySelectorAll('.kaching-bundles__bar').forEach((bar) => {
    const giftContent = bar.querySelector('.kaching-bundles__free-gift__content');
    if (!giftContent) return;

    const isSelected = bar.classList.contains('kaching-bundles__bar--selected');
    let prefixEl = giftContent.querySelector('.custom-unselected-prefix');
    let suffixEl = giftContent.querySelector('.custom-unselected-suffix');

    if (!isSelected) {
      // Add PREFIX ("Order 5 pairs and get") if missing
      if (!prefixEl) {
        prefixEl = document.createElement('div');
        prefixEl.className = 'custom-unselected-prefix';
        prefixEl.innerHTML = 'Order <span>5 pairs</span> and get';
        giftContent.prepend(prefixEl);
      }

      // Add SUFFIX ("Worth £19.95") if missing
      if (!suffixEl) {
        suffixEl = document.createElement('div');
        suffixEl.className = 'custom-unselected-suffix';
        suffixEl.innerHTML = 'Worth <span>£19.95</span>';
        giftContent.appendChild(suffixEl);
      }
    } else {
      // Remove both prefix & suffix when selected
      if (prefixEl) prefixEl.remove();
      if (suffixEl) suffixEl.remove();
    }
  });
}

// Run on page load
updateKachingElements();

// Observe dynamic app renders and user selection changes
const kachingObserver = new MutationObserver(() => {
  updateKachingElements();
});

kachingObserver.observe(document.body, {
  childList: true,
  subtree: true,
  attributes: true,
  attributeFilter: ['class']
});
